module.exports = __webpack_public_path__ + "media/images/icons/filled/reddit-circle-ed478b8dbe34bc8985bf1097c8467b49.svg";